module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av448-35e4eaeec7ce0a30c316cccaf1305e16.jpg";